import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    quarter,
    year,
    supplementaryForThe,
    firstTime,
    taxAgencyId,
    taxAgencyName,
  },
} = checkout;

const validation2 = Yup.object().shape({
  [quarter.name]: Yup.number().required(quarter.errorMsg),
  [year.name]: Yup.number().required(year.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
  .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().required(taxAgencyName.errorMsg),

});

export default validation2;
